import { createAllActions } from '@api/createArrayRequestStore';
import * as types from './types';

export const init = () => ({
  type: types.INIT,
});

export const setDimensions = dimensions => ({
  type: types.SET_DIMENSIONS,
  dimensions,
});

export const setDimension = (index, dimension) => ({
  type: types.SET_DIMENSION,
  index,
  dimension,
});

export const switchDimension = (index, target) => ({
  type: types.SWITCH_DIMENSION,
  index,
  target,
});

export const setUnit = unit => ({
  type: types.SET_UNIT,
  unit,
});

export const initRequests = () => ({
  type: types.INIT_REQUESTS,
});

export const startFetching = () => ({
  type: types.START_FETCHING,
});

export const setDimensionTablesState = state => ({
  type: types.SET_DIMENSION_TABLES_STATE,
  state,
});

export const refreshDimension = (index, dimension) => ({
  type: types.REFRESH_DIMENSION,
  index,
  dimension,
});

const {
  init: initRequest,
  initAllRequests,
  switchRequest,
  setPayload,
  setResponse,
  fetching,
  fetchingSuccess,
  fetchingFail,
  abortFetching,
} = createAllActions(types.SCOPE);

export {
  initRequest,
  initAllRequests,
  switchRequest,
  setPayload,
  setResponse,
  fetching,
  fetchingSuccess,
  fetchingFail,
  abortFetching,
};
